import React from 'react';
import {ModalIds, useModal} from "../../contexts/ModalContext";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import ClearIcon from "@mui/icons-material/Clear";
import {
    ButtonStyled,
    HrLine,
} from "../styledComponent/styledComponents";
import {DialogTitle, useMediaQuery} from "@mui/material";
import {DialogContentStyled, DialogStyled} from "./modalComponent";
import InquiryReviewSvg from '../../assets/svgs/upload-svgs/inquiryReviewSvg';


const ReviewInquiryModal = () => {
    const {handleClose, modalId} = useModal()
    const matches = useMediaQuery('(min-width:200px) and (max-width:600px)');

    return (
        <DialogStyled open={modalId === ModalIds.REVIEW_INQUIRY} onClose={handleClose}
            width={508} height={!matches ? "458px" : "420px"}
            minWidth={!matches ? "458px" : "345px"} minHeight={260}>
            <DialogContentStyled sx={{ alignItems: "center" }}>
                <Stack justifyContent={"center"} gap={1} alignItems={'center'}>
                    <InquiryReviewSvg />
                    <Typography fontSize={{ xs: 14, sm: 14 }} textAlign={"center"} color={"#464646"} lineHeight={2} pt={2}>
                        تمامی مدارک شما با موفقیت بارگذاری شده و در حال بررسی می باشد.
                        <br />
                        نتیجه بررسی از طریق پیامک به اطلاع شما خواهد رسید.
                        <br />
                        پس از تایید مدارک میتوانید ادامه فرایند را طی کنید.
                    </Typography>
                </Stack>
                <ButtonStyled onClick={handleClose} width={152} height={44} variant="contained">تایید</ButtonStyled>
            </DialogContentStyled>
        </DialogStyled>

    );
};

export default ReviewInquiryModal;